import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const LOGO = "https://customer-assets.emergentagent.com/job_utility-engine/artifacts/gzs1b04v_ChatGPT%20Image%209%20mai%202026%2C%2019_07_02.png";

const features = [
  { icon: '🛍️', title: 'Ventes & Devis', desc: 'PDFs pro générés en 1 clic. Booking, chambres, vols — tout inclus.' },
  { icon: '👥', title: 'Clients uniques', desc: 'Base centralisée, historique complet, import IA depuis emails.' },
  { icon: '📊', title: 'Stats temps réel', desc: 'Dashboards vivants, KPIs, export Excel instantané.' },
  { icon: '💰', title: 'Remboursements', desc: 'Simulateur auto : RC, RF, PF, commission. Zéro casse-tête.' },
  { icon: '✈️', title: 'Voyages & Billets', desc: 'Voyages organisés, places partagées, billetterie avion.' },
  { icon: '🤖', title: 'IA intégrée', desc: 'Programmes, suggestions de devis et résumés générés par Gemini.' },
  { icon: '🔒', title: 'Multi-agents', desc: 'Rôles, permissions granulaires, multi-tenant sécurisé.' },
  { icon: '📱', title: 'Mode Guide mobile', desc: 'QR codes embarquement, scan caméra, mode hors-ligne.' },
];

const destinations = [
  { name: 'Paris', img: 'https://images.pexels.com/photos/10719465/pexels-photo-10719465.jpeg', sales: '15 ventes' },
  { name: 'Dubai', img: 'https://images.unsplash.com/photo-1751698186759-5bac83376c9f', sales: '28 ventes' },
  { name: 'Méditerranée', img: 'https://images.pexels.com/photos/17803752/pexels-photo-17803752.jpeg', sales: '42 ventes' },
];

export default function Landing() {
  const [plans, setPlans] = useState([]);
  const [stats, setStats] = useState({ nb_agences: 0, nb_voyages: 0 });

  useEffect(() => {
    axios.get(`${API}/public/plans`).then(r => setPlans(r.data.items || [])).catch(() => {});
    axios.get(`${API}/public/stats`).then(r => setStats(r.data || { nb_agences: 0, nb_voyages: 0 })).catch(() => {});
  }, []);

  return (
    <div className="min-h-screen bg-black text-white selection:bg-orange-500/30">
      {/* NAV */}
      <nav data-testid="landing-nav" className="sticky top-0 z-50 backdrop-blur-md bg-black/70 border-b border-white/5">
        <div className="max-w-7xl mx-auto px-6 py-3 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3 group" data-testid="landing-logo">
            <img src={LOGO} alt="TripNova" className="w-11 h-11 object-contain" />
            <div className="leading-tight">
              <div className="font-extrabold tracking-tight text-lg">
                <span className="text-blue-500">TRIP</span><span className="text-orange-500">NOVA</span>
              </div>
              <span className="text-[10px] text-zinc-500 font-mono uppercase tracking-widest">CRM SaaS</span>
            </div>
          </Link>
          <div className="hidden md:flex items-center gap-7 text-sm text-zinc-300">
            <a href="#features" className="hover:text-white transition">Fonctions</a>
            <a href="#tarifs" className="hover:text-white transition">Tarifs</a>
            <Link to="/security" data-testid="landing-nav-security" className="hover:text-emerald-300 transition flex items-center gap-1">
              <span className="text-emerald-400">🛡️</span> Securite
            </Link>
            <Link to="/login" className="hover:text-white transition">Connexion</Link>
          </div>
          <Link
            to="/inscription"
            data-testid="landing-cta-signup-nav"
            className="px-4 py-2 rounded-full bg-gradient-to-r from-orange-500 to-orange-600 text-white font-semibold text-sm hover:shadow-lg hover:shadow-orange-500/30 transition"
          >
            Essai 5 jours gratuit
          </Link>
        </div>
      </nav>

      {/* HERO */}
      <section className="relative overflow-hidden">
        <div className="absolute inset-0 bg-[radial-gradient(60%_60%_at_30%_0%,rgba(59,130,246,0.18),transparent),radial-gradient(40%_40%_at_85%_30%,rgba(249,115,22,0.18),transparent)]" />
        <div className="relative max-w-7xl mx-auto px-6 pt-20 pb-28 grid md:grid-cols-2 gap-12 items-center">
          <div>
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-blue-500/10 border border-blue-500/30 text-xs text-blue-400 mb-3">
              <span className="text-orange-400">●</span> TripNova CRM — Plateforme SaaS pour agences de voyage
            </div>
            <div className="block mb-6">
              <Link
                to="/security"
                data-testid="landing-hero-security-badge"
                className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-emerald-500/10 border border-emerald-500/40 text-xs text-emerald-300 hover:bg-emerald-500/20 hover:border-emerald-400 transition"
              >
                <span>🛡️</span> Securite certifiee OWASP Top 10 — Voir le rapport →
              </Link>
            </div>
            <h1 className="text-5xl md:text-7xl font-black leading-[1.05] tracking-tight">
              Votre CRM voyage,<br/>
              <span className="bg-gradient-to-r from-blue-500 via-blue-400 to-orange-500 bg-clip-text text-transparent">simple et rapide.</span>
            </h1>
            <p className="mt-6 text-lg text-zinc-300 max-w-xl leading-relaxed">
              Gérez vos ventes, paiements, remboursements et voyages.<br/>
              <span className="text-zinc-400">Sans friction. Sans prise de tête. 🌊</span>
            </p>
            <div className="mt-10 flex flex-wrap gap-4">
              <Link
                to="/inscription"
                data-testid="landing-cta-signup-hero"
                className="px-7 py-3.5 rounded-full bg-gradient-to-r from-orange-500 to-orange-600 text-white font-bold hover:shadow-xl hover:shadow-orange-500/40 transition text-base"
              >
                Créer mon agence →
              </Link>
              <a
                href={`${API}/public/plaquette-tripnova.pdf`}
                target="_blank"
                rel="noreferrer"
                data-testid="landing-cta-plaquette"
                className="px-6 py-3 rounded-full border border-blue-500/40 text-blue-300 font-semibold hover:bg-blue-500/10 hover:border-blue-400/60 transition inline-flex items-center gap-2"
              >
                <span>📄</span> Télécharger la plaquette
              </a>
              <a
                href="#features"
                className="px-6 py-3 rounded-full border border-white/20 text-white font-semibold hover:bg-white/5 hover:border-blue-400/40 transition"
              >
                Voir les fonctions
              </a>
            </div>
            <div className="mt-12 grid grid-cols-3 gap-6 max-w-md">
              <div><div className="text-2xl font-black text-blue-400" data-testid="hero-stat-agences">{stats.nb_agences || '—'}</div><div className="text-xs text-zinc-400 mt-1">Agences actives</div></div>
              <div><div className="text-2xl font-black text-orange-400">99,9%</div><div className="text-xs text-zinc-400 mt-1">Uptime</div></div>
              <div><div className="text-2xl font-black text-blue-400">24/7</div><div className="text-xs text-zinc-400 mt-1">Support</div></div>
            </div>
          </div>

          {/* Floating card preview */}
          <div className="relative">
            <div className="absolute -inset-4 bg-gradient-to-br from-blue-500/25 to-orange-500/25 rounded-3xl blur-3xl" />
            <div className="relative bg-white rounded-2xl shadow-2xl overflow-hidden text-zinc-800 transform rotate-1 hover:rotate-0 transition-transform">
              <img src="https://images.pexels.com/photos/17803752/pexels-photo-17803752.jpeg" alt="Méditerranée" className="w-full h-44 object-cover"/>
              <div className="p-5 space-y-3">
                <div className="flex justify-between items-baseline">
                  <div>
                    <div className="text-xs text-zinc-500 uppercase tracking-wider">Destination</div>
                    <div className="text-lg font-bold">Santorini, Grèce</div>
                  </div>
                  <span className="px-2 py-0.5 text-xs rounded-full bg-emerald-100 text-emerald-700 font-semibold">Payée</span>
                </div>
                <div className="grid grid-cols-3 gap-3 pt-3 border-t border-zinc-100">
                  <div><div className="text-[10px] text-zinc-500 uppercase">Client</div><div className="text-sm font-semibold mt-0.5">Salma K.</div></div>
                  <div><div className="text-[10px] text-zinc-500 uppercase">Total</div><div className="text-sm font-semibold mt-0.5">85 000 DZD</div></div>
                  <div><div className="text-[10px] text-zinc-500 uppercase">Départ</div><div className="text-sm font-semibold mt-0.5">15 mai</div></div>
                </div>
              </div>
            </div>
            <div className="absolute -bottom-4 -right-4 bg-black border border-orange-500/40 rounded-xl px-4 py-3 shadow-xl">
              <div className="text-[10px] text-zinc-400 uppercase">Ce mois</div>
              <div className="text-xl font-black bg-gradient-to-r from-blue-400 to-orange-400 bg-clip-text text-transparent">+42 ventes</div>
              <div className="text-xs text-zinc-300">3 nouvelles demandes</div>
            </div>
          </div>
        </div>
      </section>

      {/* TRUST STRIP — Preuve sociale B2B */}
      <section className="py-12 md:py-16 border-t border-white/5 relative overflow-hidden">
        <div className="absolute inset-0 bg-[radial-gradient(50%_50%_at_50%_50%,rgba(249,115,22,0.08),transparent)]" />
        <div className="relative max-w-6xl mx-auto px-6">
          <div className="text-center mb-10">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-orange-500/10 border border-orange-500/30 text-xs text-orange-400">
              <span className="w-1.5 h-1.5 rounded-full bg-emerald-400 animate-pulse" />
              Live · mis a jour en temps reel
            </div>
            <h2 className="mt-5 text-3xl md:text-5xl font-black tracking-tight">
              Deja <span className="bg-gradient-to-r from-orange-400 to-blue-400 bg-clip-text text-transparent">{stats.nb_agences}</span> agences
              <br className="md:hidden" /> nous font confiance.
            </h2>
            <p className="mt-4 text-zinc-400 max-w-2xl mx-auto text-sm md:text-base">
              TripNova est utilise quotidiennement par des agences de voyage en Algerie et au Maghreb pour gerer ventes, voyages et clients.
            </p>
          </div>

          <div className="grid grid-cols-3 gap-3 md:gap-6">
            <div
              data-testid="landing-stat-agences"
              className="p-5 md:p-8 rounded-3xl bg-white/[0.03] border border-orange-500/20 hover:border-orange-400/50 transition text-center"
            >
              <div className="text-4xl md:text-6xl font-black bg-gradient-to-br from-orange-400 to-orange-600 bg-clip-text text-transparent">
                {stats.nb_agences}
              </div>
              <div className="text-[10px] md:text-xs text-zinc-400 uppercase tracking-widest mt-2">
                Agences actives
              </div>
            </div>
            <div
              data-testid="landing-stat-voyages"
              className="p-5 md:p-8 rounded-3xl bg-white/[0.03] border border-blue-500/20 hover:border-blue-400/50 transition text-center"
            >
              <div className="text-4xl md:text-6xl font-black bg-gradient-to-br from-blue-400 to-blue-600 bg-clip-text text-transparent">
                {stats.nb_voyages}
              </div>
              <div className="text-[10px] md:text-xs text-zinc-400 uppercase tracking-widest mt-2">
                Voyages publies
              </div>
            </div>
            <div
              data-testid="landing-stat-uptime"
              className="p-5 md:p-8 rounded-3xl bg-white/[0.03] border border-emerald-500/20 hover:border-emerald-400/50 transition text-center"
            >
              <div className="text-4xl md:text-6xl font-black bg-gradient-to-br from-emerald-400 to-emerald-600 bg-clip-text text-transparent">
                99,9%
              </div>
              <div className="text-[10px] md:text-xs text-zinc-400 uppercase tracking-widest mt-2">
                Uptime garanti
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FEATURES */}
      <section id="features" className="py-24 border-t border-white/5">
        <div className="max-w-7xl mx-auto px-6">
          <div className="mb-14">
            <div className="text-xs text-orange-400 uppercase tracking-widest font-mono mb-3">Fonctionnalités</div>
            <h2 className="text-4xl md:text-5xl font-black tracking-tight">Tout ce qu'il faut. <span className="text-zinc-500">Rien de plus.</span></h2>
          </div>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-5">
            {features.map((f, i) => (
              <div
                key={f.title || f.id || `landing-feat-${i}`}
                data-testid={`landing-feature-${i}`}
                className="group p-6 rounded-2xl bg-white/[0.03] border border-white/5 hover:border-blue-500/40 hover:bg-blue-500/5 transition"
              >
                <div className="text-3xl mb-4">{f.icon}</div>
                <div className="font-bold text-lg mb-2">{f.title}</div>
                <div className="text-sm text-zinc-400 leading-relaxed">{f.desc}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* DESTINATIONS */}
      <section className="py-24 border-t border-white/5">
        <div className="max-w-7xl mx-auto px-6">
          <div className="mb-14">
            <div className="text-xs text-orange-400 uppercase tracking-widest font-mono mb-3">Vos destinations</div>
            <h2 className="text-4xl md:text-5xl font-black tracking-tight">Faites rêver. <span className="text-zinc-500">Nous gérons.</span></h2>
          </div>
          <div className="grid md:grid-cols-3 gap-5">
            {destinations.map((d, i) => (
              <div key={d.name || `landing-dest-${i}`} className="relative group rounded-2xl overflow-hidden h-72 cursor-pointer">
                <img src={d.img} alt={d.name} className="absolute inset-0 w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"/>
                <div className="absolute inset-0 bg-gradient-to-t from-black via-black/40 to-transparent"/>
                <div className="absolute bottom-0 left-0 right-0 p-5">
                  <span className="inline-block px-2 py-1 text-[10px] uppercase tracking-wider rounded-full bg-orange-500 text-white font-bold mb-2">{d.sales}</span>
                  <div className="text-2xl font-black">{d.name}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* TARIFS */}
      <section id="tarifs" className="py-24 border-t border-white/5">
        <div className="max-w-7xl mx-auto px-6">
          <div className="mb-14 text-center">
            <div className="text-xs text-orange-400 uppercase tracking-widest font-mono mb-3">Tarifs</div>
            <h2 className="text-4xl md:text-5xl font-black tracking-tight">Des prix doux.</h2>
            <p className="mt-3 text-zinc-400">Essai gratuit 5 jours. Sans CB. Sans engagement.</p>
          </div>
          <div className="grid md:grid-cols-4 gap-4">
            {plans.map((p) => (
              <div
                key={p.id}
                data-testid={`landing-plan-${p.code}`}
                className={`relative p-6 rounded-2xl border transition ${p.is_popular ? 'border-orange-500 bg-gradient-to-br from-orange-500/10 to-blue-500/5' : 'border-white/10 bg-white/[0.02] hover:border-blue-500/30'}`}
              >
                {p.is_popular && (
                  <div className="absolute -top-3 left-6 px-3 py-1 text-[10px] uppercase tracking-wider bg-gradient-to-r from-orange-500 to-orange-600 text-white rounded-full font-bold shadow-lg shadow-orange-500/30">⭐ Le + populaire</div>
                )}
                <div className="text-zinc-400 text-sm">{p.nom}</div>
                <div className="mt-3 flex items-baseline gap-1">
                  <span className={`text-4xl font-black ${p.is_popular ? 'text-orange-400' : 'text-white'}`}>{p.prix_dzd.toLocaleString('fr-FR')}</span>
                  <span className="text-xs text-zinc-500">DZD</span>
                </div>
                {p.discount_pct > 0 && (
                  <div className="mt-1 inline-block px-2 py-0.5 text-[10px] rounded-full bg-blue-500/20 text-blue-300">-{p.discount_pct}%</div>
                )}
                <ul className="mt-5 space-y-2 text-sm text-zinc-300">
                  {(p.features || []).map((f, i) => (<li key={`${p.id || p.name || 'plan'}-feat-${typeof f === 'string' ? f : i}`} className="flex items-start gap-2"><span className="text-orange-400">✓</span>{f}</li>))}
                </ul>
                <Link
                  to="/inscription"
                  data-testid={`landing-plan-cta-${p.code}`}
                  className={`mt-6 block text-center px-4 py-2.5 rounded-full font-semibold transition ${p.is_popular ? 'bg-gradient-to-r from-orange-500 to-orange-600 text-white hover:shadow-lg hover:shadow-orange-500/30' : 'bg-blue-500/15 text-blue-300 hover:bg-blue-500/25'}`}
                >
                  Commencer →
                </Link>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* SECURITE — confiance et conformite OWASP */}
      <section className="py-24 border-t border-white/5 relative overflow-hidden">
        <div className="absolute inset-0 bg-[radial-gradient(50%_50%_at_50%_50%,rgba(16,185,129,0.08),transparent)]" />
        <div className="relative max-w-6xl mx-auto px-6">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div>
              <div className="text-xs text-emerald-400 uppercase tracking-widest font-mono mb-3">Securite</div>
              <h2 className="text-4xl md:text-5xl font-black tracking-tight">
                Vos donnees, <span className="bg-gradient-to-r from-emerald-400 to-blue-400 bg-clip-text text-transparent">en coffre-fort.</span>
              </h2>
              <p className="mt-5 text-zinc-300 leading-relaxed text-base">
                Audit OWASP Top 10 complet, isolation multi-tenant stricte, 2FA TOTP,
                cookies <code className="text-emerald-300 bg-emerald-500/10 px-1.5 py-0.5 rounded text-xs font-mono">__Host-</code>,
                backups quotidiens off-site et audit logs avec detection brute force.
              </p>
              <div className="mt-7 flex flex-wrap gap-3">
                <Link
                  to="/security"
                  data-testid="landing-security-cta"
                  className="px-6 py-3 rounded-full bg-gradient-to-r from-emerald-500 to-blue-500 text-white font-bold hover:shadow-xl hover:shadow-emerald-500/40 transition inline-flex items-center gap-2"
                >
                  🛡️ Voir la politique de securite
                </Link>
              </div>
            </div>
            <div className="grid grid-cols-2 gap-3">
              {[
                { icon: '🛡️', label: 'OWASP Top 10', sub: 'Conforme 2021' },
                { icon: '🔐', label: '2FA TOTP', sub: 'RFC 6238' },
                { icon: '🏢', label: 'Multi-tenant', sub: 'Isolation stricte' },
                { icon: '💾', label: 'Backups', sub: 'Quotidiens 90j' },
                { icon: '📋', label: 'Audit logs', sub: 'Retention longue' },
                { icon: '🔒', label: 'Chiffrement', sub: 'bcrypt + Fernet' },
              ].map((b, i) => (
                <div
                  key={b.title || b.label || `landing-sec-${i}`}
                  data-testid={`landing-security-feature-${i}`}
                  className="p-4 rounded-2xl bg-white/[0.03] border border-emerald-500/15 hover:border-emerald-400/40 hover:bg-emerald-500/5 transition"
                >
                  <div className="text-2xl mb-2">{b.icon}</div>
                  <div className="font-bold text-sm text-white">{b.label}</div>
                  <div className="text-xs text-zinc-400 mt-0.5">{b.sub}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* CTA FINAL */}
      <section className="py-24 border-t border-white/5">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <div className="flex justify-center mb-8">
            <img src={LOGO} alt="TripNova" className="w-24 h-24 object-contain opacity-80" />
          </div>
          <h2 className="text-4xl md:text-5xl font-black tracking-tight">On commence aujourd'hui ? 🚀</h2>
          <p className="mt-4 text-zinc-400 text-lg">5 jours gratuits. Zéro engagement. Promis, vous allez adorer.</p>
          <Link
            to="/inscription"
            data-testid="landing-cta-signup-final"
            className="inline-block mt-10 px-8 py-4 rounded-full bg-gradient-to-r from-orange-500 to-orange-600 text-white font-bold text-lg hover:shadow-2xl hover:shadow-orange-500/40 transition"
          >
            Créer mon agence
          </Link>
        </div>
      </section>

      <footer className="py-10 border-t border-white/5 text-center text-xs text-zinc-500">
        © {new Date().getFullYear()} <span className="text-blue-400">TRIP</span><span className="text-orange-400">NOVA</span> CRM • Plateforme SaaS multi-agences pour la voyage
        <div className="mt-2 flex flex-wrap items-center justify-center gap-x-2 gap-y-1">
          <Link to="/security" data-testid="landing-footer-security" className="text-emerald-400 hover:text-emerald-300 transition">🛡️ Politique de securite</Link>
          <span className="text-zinc-700">•</span>
          <Link to="/cgu" data-testid="landing-footer-cgu" className="hover:text-zinc-300 transition">CGU</Link>
          <span className="text-zinc-700">•</span>
          <Link to="/cgv" data-testid="landing-footer-cgv" className="hover:text-zinc-300 transition">CGV</Link>
          <span className="text-zinc-700">•</span>
          <Link to="/rgpd" data-testid="landing-footer-rgpd" className="hover:text-zinc-300 transition">RGPD</Link>
          <span className="text-zinc-700">•</span>
          <Link to="/mentions-legales" data-testid="landing-footer-mentions" className="hover:text-zinc-300 transition">Mentions légales</Link>
          <span className="text-zinc-700">•</span>
          <a href="mailto:aatvgeste@gmail.com" className="hover:text-zinc-300 transition">Contact</a>
        </div>
      </footer>
    </div>
  );
}
